import Router from 'vue-router'
import Default from '@/components/Default'
import SearchResults from '@/components/SearchResults'
import { validLanguage, defaultLanguage  } from '@/util/lang'

export function createRouter () {
  let router = new Router({
    mode: 'history',
    routes: [
      {
        path: '/:language',
        name: 'Home',
        component: Default,
        meta: { 
          showMap: true,
          resizeSearch: true
        },
      },
      {
        path: '/:language/search',
        name: 'Search',
        //component: () => import('../components/SearchResults.vue'),
        component: SearchResults,
        meta: { 
          titleKey: 'resultsTitle',
          showMap: true
        },
      },
      {
        path: '/:language/applications/:id',
        name: 'Devapp',
        component: () => import('../components/DevappDetails.vue'),
        //component: DevappDetails,
        children: [
          {
            path: 'details',
            name: 'DevappDetails',
            component: () => import('../components/DevappAttachments.vue'),
            //component: DevappAttachments,
            meta: { 
              titleKey: 'detailsTitle',
              showMap: false
            },
          },
        ],
      },
    ],
    navHooks: [ ]
  })

  router.beforeEach((to, from, next) => {
    // Ensure there's a valid language set, and if not, redirect to a 
    // known location
    if (!to.params.language || !validLanguage(to.params.language)) {
      next(`/${defaultLanguage()}`)
    } else {
      // Set some document attributes based on this path
      let i18n = router.app.$i18n
      document.title = (to.meta.titleKey ? i18n.t(to.meta.titleKey) + ' - ' : '') + i18n.t('appTitle')
      document.documentElement.lang = to.params.language
      next()  
    }

    // Run through any navigation hooks, giving components a chance to
    // observe or update their states
    for (let navHook of router.options.navHooks) {
      try {
        navHook(to, from)
      } catch (ex) {
        // Just swallow it
      }
    }
  })
  return router
}